import React from 'react';
import PropTypes from 'prop-types';
import { Input, DatePicker } from 'antd';

export const PROFORMA_DATE_FORMAT = 'DD-MM-YYYY';
export const PROFORMA_API_DATE_FORMAT = 'YYYY-MM-DD';
export const PROFORMA_INVOICE_NUMBER_MAX_LENGTH = 100;

const fieldStyle = { width: '100%', display: 'flex', flexDirection: 'column', gap: 4 };
const labelStyle = { fontSize: 14, fontWeight: 500, color: '#18405d' };

/**
 * Invoice number and invoice date of an uploaded pro-forma. Same two inputs the vendor-invoice
 * upload shows, both optional.
 */
function ProformaInvoiceDetailsFields({
	idPrefix,
	invoiceNumber,
	invoiceDate,
	onInvoiceNumberChange,
	onInvoiceDateChange,
}) {
	return (
		<div style={{ width: 348, display: 'flex', flexDirection: 'column', gap: 16 }}>
			<div style={fieldStyle}>
				<label htmlFor={`${idPrefix}-invoice-number`} style={labelStyle}>
					Invoice Number
				</label>
				<Input
					id={`${idPrefix}-invoice-number`}
					placeholder="Enter invoice number"
					value={invoiceNumber}
					maxLength={PROFORMA_INVOICE_NUMBER_MAX_LENGTH}
					onChange={(e) => onInvoiceNumberChange(e.target.value)}
				/>
			</div>
			<div style={fieldStyle}>
				<label htmlFor={`${idPrefix}-invoice-date`} style={labelStyle}>
					Invoice Date
				</label>
				<DatePicker
					id={`${idPrefix}-invoice-date`}
					style={{ width: '100%' }}
					format={PROFORMA_DATE_FORMAT}
					placeholder="Select invoice date"
					value={invoiceDate}
					onChange={onInvoiceDateChange}
				/>
			</div>
		</div>
	);
}

ProformaInvoiceDetailsFields.propTypes = {
	idPrefix: PropTypes.string.isRequired,
	invoiceNumber: PropTypes.string.isRequired,
	// moment object (antd v4 DatePicker) or null
	invoiceDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	onInvoiceNumberChange: PropTypes.func.isRequired,
	onInvoiceDateChange: PropTypes.func.isRequired,
};

ProformaInvoiceDetailsFields.defaultProps = {
	invoiceDate: null,
};

export default ProformaInvoiceDetailsFields;
